import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";
import {DbStoreState} from "../../../../store";
import {Store} from '@ngrx/store';
import {RouteDataService} from "../../../../shared/services/route-data/route-data.service";
import {GoogleAnalyticsService} from "../../../../shared/services/google-analytics/google-analytics.service";
import * as fromStore from "../../../../store";
import {filter, first, switchMap, takeUntil} from "rxjs/operators";
import {User} from "../../../../user/user";
import {Subject} from "rxjs";
import {UserService} from "../../../../user/user.service";
import {DbResponse} from "../../../../shared/interceptors/db-response";
import {GlobalEvent} from "../../../../shared/services/global-event-dispatcher/global-event";
import {GlobalEventDispatcherService} from "../../../../shared/services/global-event-dispatcher/global-event-dispatcher.service";
import {AuthService} from "../../../../auth/auth.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DbValidators} from "../../../../shared/validators/DbValidators";
import {ProductService} from "../../../../websites/website/product.service";
import {Config} from "../../../../config/config";

@Component({
    selector: 'db-start-booster',
    templateUrl: './start-booster.component.html',
    styleUrls: ['./start-booster.component.scss'],
    standalone: false
})
export class StartBoosterComponent implements OnInit, OnDestroy {

  public pageId;
  public user: User;
  public message: string;
  public messageSent: boolean;
  public otherForm: FormGroup;
  public loading: boolean;
  public blocks: any;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _store: Store<DbStoreState>,
    private _router: Router,
    private _routeDataService: RouteDataService,
    private _userService: UserService,
    private _productService: ProductService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _globalEventDispatcher: GlobalEventDispatcherService,
    private _authService: AuthService
  ) {}

  ngOnInit() {
    this.blocks = [
      {
        title: "Up to 7%",
        desc: "increased<br/> conversions",
        img: "assets/images/icons/up-to-7.png"
      },
      {
        title: "Up to 40%",
        desc: "boost in<br/> visitor engagement",
        img: 'assets/images/icons/up-to-40.png'
      },
      {
        title: "Up to 53%",
        desc: "increase in mobile<br/> traffic engagement",
        img: 'assets/images/icons/up-to-53.png'
      }
    ]
    this.pageId = this._routeDataService.getCurrentRouteData().pageId;
    this.otherForm = new FormGroup({
      'otherType': new FormControl("", [Validators.required]),
      'message': new FormControl("", [DbValidators.trimStart, Validators.required])
    });
    this.routerEvents();
    this.getUser();

  }

  public routerEvents(): void {
      this._router.events
        .pipe(filter((event: any) => event instanceof NavigationEnd))
        .subscribe(() => {
          this.pageId = this._router && this._router.url.split("/").pop();
        });
  }

  public getUser(): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUser)),
        filter((user: User) => !!user),
        takeUntil(this._destroyStream$)
      )
      .subscribe((user: User) => {
        this.user = user;
      });
  }

  public submit() {
    const chatStatus = window['zE']('messenger:get', 'chat:department', 'Support') && window['zE']('messenger:get', 'chat:department', 'Support').status;
    this.formSubmitted(chatStatus === 'online');
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

  public formSubmitted(hasOnlineAgentInChat: boolean): void {
    if (!this.messageSent) {
      this._globalEventDispatcher.dispatchEvent(GlobalEvent.hideOnboardingBackButton, 1);
      this.loading = true;
      if (this.otherForm.controls['message'].value) {
        const data = {
          comment: this.otherForm.controls['message'].value,
          subject: 'Looking for Something Else',
        };
        this._userService.createZendeskTicket(data)
          .pipe(filter((response: DbResponse): boolean => !!response),
          first())
          .subscribe((response) => {
            this._globalEventDispatcher.dispatchEvent(GlobalEvent.hideOnboardingBackButton, 1);
            if (this.user && this.user.signUpFor) {
              this.user.signUpFor['Action'] = {answer: 'Other - ' + this.otherForm.controls['otherType'].value, id: ''};
              this._authService.updateSignUpFor(this.user.signUpFor, true)
                .pipe(filter((_response: DbResponse): boolean => !!_response),
                first())
                .subscribe((_response) => {
                  this.loading = false;
                  if (response.success) {
                    this.messageSent = !hasOnlineAgentInChat;
                    this.formSubmitEventEvent(hasOnlineAgentInChat);
                  }
                });
            }
            else {
              this.messageSent = !hasOnlineAgentInChat;
              this.formSubmitEventEvent(hasOnlineAgentInChat);
            }
          });
      }
    }
    else {
      this._router.navigate(['/websites']);
    }
  }

  public openChat(hasOnlineAgentInChat): void {
    if (hasOnlineAgentInChat) {
      /*window['zE']('messenger', 'chat:removeTags', ['generic_support']);
      window['zE']('messenger', 'chat:addTags', [this.otherForm.controls.otherType.value]);*/

      window['Smooch']?.open();
     /* window['zE']('messenger', 'chat:send', this.otherForm.controls.message.value);*/
      this._store.dispatch(new fromStore.ToggleChatOverlay(false));
      this._router.navigate(['/websites']);
    }
    else {
      this._router.navigate(['/websites']);
    }
  }

  public formSubmitEventEvent(hasOnlineAgentInChat: boolean): void {
    const signUpForAnswer = this.user && this.user.signUpFor
    && this.user.signUpFor.Action && this.user.signUpFor.Action.answer ? this.user.signUpFor.Action.answer : '';
    const analyticsData = {
      eventCategory: 'Onboarding',
      eventAction: 'Other',
      eventLabel: 'Submit - ' + signUpForAnswer
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
    this.openChat(hasOnlineAgentInChat);
  }

  public downloadBoosterPlugin(): void {
    window.location.href = Config.boosterAutoConnectVersion;
  }

}
